var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Edit details",
        label: "Update",
        submitLoading: _vm.submitLoading,
        disabled: _vm.isDisabledSubmit
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSubmit
      }
    },
    [
      _vm.modalLoading
        ? _c(
            "div",
            {
              staticClass: "grid items-center justify-center gap-4 px-8 h-100",
              style: { width: "48rem" }
            },
            [_c("div", { staticClass: "blum-loader" })]
          )
        : _c(
            "div",
            {
              staticClass: "grid items-center grid-cols-2 gap-4 px-8",
              style: { width: "48rem" }
            },
            [
              _c("BlInputText", {
                staticClass: "col-span-2",
                attrs: { input: _vm.nameInput },
                on: { changed: _vm.inputHandler }
              }),
              _vm._v(" "),
              _c("BlSelectBox", {
                attrs: {
                  label: "Curriculum",
                  asterisk: "",
                  search: "",
                  placeholder: "Select curriculum",
                  options: [
                    {
                      value: _vm.target.curriculum_id,
                      label: _vm.target.curriculum_name,
                      prefixColor: _vm.target.curriculum_color
                    }
                  ],
                  fetchProperty: {
                    url: "/api/v1/curriculums?sort=name_asc&query=",
                    dataKey: "curriculums",
                    countKey: "total_count",
                    optionKeys: {
                      value: "id",
                      label: "name",
                      prefixColor: "color"
                    }
                  }
                },
                on: {
                  change: function($event) {
                    _vm.curriculumIdInput = $event
                  }
                },
                model: {
                  value: _vm.curriculumIdInput,
                  callback: function($$v) {
                    _vm.curriculumIdInput = $$v
                  },
                  expression: "curriculumIdInput"
                }
              }),
              _vm._v(" "),
              !_vm.panelId
                ? _c("BlSelectBox", {
                    attrs: {
                      label: "Status",
                      asterisk: "",
                      placeholder: "Select status",
                      options: _vm.statusOptions
                    },
                    on: {
                      change: function($event) {
                        _vm.statusInput = $event
                      }
                    },
                    model: {
                      value: _vm.statusInput,
                      callback: function($$v) {
                        _vm.statusInput = $$v
                      },
                      expression: "statusInput"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.panelId
                ? _c("BlInputDate", {
                    attrs: { input: _vm.dateIntroduceInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.panelId
                ? _c("BlInputDate", {
                    attrs: { input: _vm.dateMasteredInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("BlInputText", {
                staticClass: "col-span-2",
                attrs: { input: _vm.descriptionInput },
                on: { changed: _vm.inputHandler }
              }),
              _vm._v(" "),
              _vm.target.type.includes("Pir")
                ? _c("BlInputText", {
                    attrs: { input: _vm.intervalInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.target.type.includes("Pir")
                ? _c("BlInputText", {
                    attrs: { input: _vm.durationInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.target.type.includes("Percentage") ||
              _vm.target.type.includes("Pir")
                ? _c("BlInputText", {
                    attrs: { input: _vm.goalInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.target.type.includes("Duration")
                ? _c("BlInputTime", {
                    attrs: { input: _vm.timeInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.target.type.includes("Frequency")
                ? _c("BlInputText", {
                    attrs: { input: _vm.goalFrequencyInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.target.type.includes("Prompting")
                ? _c(
                    "div",
                    { staticClass: "flex flex-col col-span-2 gap-4 pt-8" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        [
                          _c("BlTextSubtitle1", {
                            attrs: { text: "Goal and success metric" }
                          }),
                          _vm._v(" "),
                          _vm.promptingFormatInput === "classic"
                            ? _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "Mark this target as successful when the client uses a specific prompt at least a certain number of times."
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.promptingFormatInput === "custom"
                            ? _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "The target passes if the client's score meets the goal you set."
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.promptingFormatInput === "classic"
                        ? _c(
                            "div",
                            { staticClass: "grid grid-cols-2 gap-4" },
                            [
                              _c("BlSelectBox", {
                                key:
                                  "success-metric-" +
                                  JSON.stringify(_vm.defaultPrompts),
                                attrs: {
                                  label: "Prompt level",
                                  asterisk: "",
                                  placeholder: "Select prompt",
                                  options: _vm.defaultPrompts.map(function(i) {
                                    return { value: i.name, label: i.name }
                                  }),
                                  drop: "up",
                                  position: "top"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.successMetricInput = $event
                                  }
                                },
                                model: {
                                  value: _vm.successMetricInput,
                                  callback: function($$v) {
                                    _vm.successMetricInput = $$v
                                  },
                                  expression: "successMetricInput"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlInputText", {
                                attrs: { input: _vm.goalPromptInput },
                                on: { changed: _vm.inputHandler }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.promptingFormatInput === "custom"
                        ? _c(
                            "div",
                            { staticClass: "grid grid-cols-2 gap-4" },
                            [
                              _c("BlInputText", {
                                attrs: { input: _vm.goalInput },
                                on: { changed: _vm.inputHandler }
                              }),
                              _vm._v(" "),
                              _c("BlSelectBox", {
                                attrs: {
                                  label: "Success metric",
                                  asterisk: "",
                                  placeholder: "Select success metric",
                                  options: _vm.successMetricOptions
                                },
                                on: {
                                  change: function($event) {
                                    _vm.successMetricInput = $event
                                  }
                                },
                                model: {
                                  value: _vm.successMetricInput,
                                  callback: function($$v) {
                                    _vm.successMetricInput = $$v
                                  },
                                  expression: "successMetricInput"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : !_vm.target.type.includes("Sbt")
                ? _c("BlSelectBox", {
                    attrs: {
                      label: "Success metric",
                      asterisk: "",
                      placeholder: "Select success metric",
                      options: _vm.successMetricOptions
                    },
                    on: {
                      change: function($event) {
                        _vm.successMetricInput = $event
                      }
                    },
                    model: {
                      value: _vm.successMetricInput,
                      callback: function($$v) {
                        _vm.successMetricInput = $$v
                      },
                      expression: "successMetricInput"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.target.type.includes("Percentage")
                ? _c("BlInputText", {
                    attrs: { input: _vm.trialsInput },
                    on: { changed: _vm.inputHandler }
                  })
                : _vm._e()
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6857b4ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6857b4ff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/modal/EditTargetDetailsModal.vue
// module id = null
// module chunks = 